import type { TFunction } from 'i18next';
import type { RegionalOverviewDigitalTrapGroup } from 'querys/regional-overview/regional-overview.query.models';

export const translateEppoCode = (key: 'crop_eppo_code' | 'pest_eppo_code', eppoCode: string, t: TFunction): string => {
  const translationKey = `pages.regional_overview.digital_traps.${key}.${eppoCode.toLowerCase()}`;
  const translatedValue = t(translationKey);
  const isTranslationAvailable = translatedValue !== translationKey;

  return isTranslationAvailable ? translatedValue : eppoCode;
};

export const translateGroupName = (group: RegionalOverviewDigitalTrapGroup, t: TFunction): string => {
  if (group.custom_group) return group.name;
  if (!group.pest_eppo_code) return group.pest_eppo_name;

  return translateEppoCode('pest_eppo_code', group.pest_eppo_code, t);
};
